// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87ea0232","453":"07b0978f","455":"80b19217","977":"cabd642d"}[chunkId] + ".chunk.js";
};